import ENV_CONFIG from './envConfig';

// Function to get current environment configuration
function getCurrentConfig() {
  const baseUrl = window.baseUrl;
  const config = ENV_CONFIG[baseUrl];

  if (!config) {
    console.warn(`No configuration found for baseUrl: ${baseUrl}`);
    // Return default config or the first available config
    return ENV_CONFIG[Object.keys(ENV_CONFIG)[0]];
  }

  return config;
}

// API Configuration
export const apiBaseUrl = `${window.baseUrl}`;

// Get app version from environment config
export const APP_VERSION = getCurrentConfig().appVersion;

// Export the config getter for other uses
export { getCurrentConfig };
